export default __webpack_public_path__ + "static/media/Jenny_Timur-171_websize_tn.c6b5a5e3.jpg";